export type ElementChild = Node | string | null | undefined | false;

export function element<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  className: string | null = null,
  ...children: readonly ElementChild[]
): HTMLElementTagNameMap[K] {
  const result = document.createElement(tag);
  if (className !== null) result.className = className;
  append(result, ...children);
  return result;
}

export function append(parent: Node, ...children: readonly ElementChild[]): void {
  for (const child of children) {
    if (child === null || child === undefined || child === false) continue;
    parent.appendChild(child instanceof Node ? child : document.createTextNode(child));
  }
}

export function button(
  label: string,
  className: string,
  action: () => void | Promise<void>,
  disabled = false,
): HTMLButtonElement {
  const result = element("button", className, label);
  result.type = "button";
  result.disabled = disabled;
  result.addEventListener("click", () => void action());
  return result;
}

export function heading(
  level: 1 | 2 | 3,
  text: string,
  className: string | null = null,
): HTMLHeadingElement {
  return element(`h${level}`, className, text) as HTMLHeadingElement;
}
